import Vue from "vue";
import KnockOut from "knockout";
import Axios from "axios";

import DataWebConfig from "@Scripts/Config/DataWebConfig";
import AppConfig from "@Scripts/Config/AppConfig";
import { router } from "@Scripts/Config/RouteConfig";
import { store } from "@Scripts/Config/StoreConfig";

import Localizer from "@Scripts/Common/Localizer";
import CartPreviewViewModel from "@Scripts/ViewModels/CartPreviewViewModel";
import SearchViewModel from "@Scripts/ViewModels/SearchViewModel";
import CookieHelper from "@Scripts/Common/CookieHelper";
import GTagHelper from "@Scripts/Infrastructure/GTagHelper";

export default class BasePage {
    public static async init() {
        await Localizer.init({
            defaultCulture: (<any>window).App.culture,
            resourceContexts: ["App", "Account", "Cart", "Checkout", "InfoRequest", "Newsletter", "Review", "SEO"]
        });

        let DataWeb = (<any>window).DataWeb;
        if (DataWeb) {
            Vue.use(DataWeb.default);
            Vue.use(DataWebConfig);

            await DataWeb.Localizer.init({ defaultCulture: (<any>window).App.userCulture, resourceContexts: ["DataWeb", "Account"] });
        }

        this.initRequestVerificationToken();

        AppConfig.AddComponents();

        let vm = new Vue({
            el: "#app",
            router,
            store,
            created() {
                if (DataWeb) {
                    DataWeb.default.registerRoutes(router);
                    DataWeb.default.registerStoreModules(store);
                }
            }
        });

        (<any>window).App.instances.vm = vm;

        this.resetCssAnimations();
        this.onLoad();
        this.setAnalytics();
        this.setTooltipNewsletter();
        this.wrapMenu();

        let self = this;

        $(window).on("resize", function () {
            self.setAppHeader();
        }).resize();

        if ((<any>window).App.bag?.storeCategory) {
            this.setCatalogueMenu();
        }

        if (document.getElementById("CartPreview")) {
            (<any>window).App.viewModels.cartPreview = new CartPreviewViewModel();
            KnockOut.applyBindings((<any>window).App.viewModels.cartPreview, document.getElementById("CartPreview"));
        }

        if (document.getElementById("SearchBox")) {
            (<any>window).App.viewModels.search = new SearchViewModel();
            KnockOut.applyBindings((<any>window).App.viewModels.search, document.getElementById("SearchBox"));
        }

        $(".search-button.open").on("click", function () {
            $(".menu").attr("data-show", "false");
            $(".search").attr("data-show", "true");
            $(".wrap-tap").fadeIn();

            setTimeout(function () {
                $(".search .search-input .input-box input.textbox")[0].focus();
            }, 450);
        });
    }

    private static initRequestVerificationToken() {
        var antiforgerytoken = (<any>document.getElementsByName("__RequestVerificationToken")[0]).value;
        if (antiforgerytoken) {
            Axios.defaults.headers.common["RequestVerificationToken"] = antiforgerytoken;
        }
    }

    private static resetCssAnimations() {
        (<any>window).addEventListener("load", function () {
            let loaders = document.getElementsByClassName("loader");
            for (let i = 0; i < loaders.length; i++) {
                loaders[i].classList.add("hide");
            }

            let preLoaders = document.querySelectorAll("[data-preload]");
            for (let i = 0; i < preLoaders.length; i++) {
                preLoaders[i].removeAttribute("data-preload");
            }
        });
    }

    private static onLoad() {
        let vm = this;

        (<any>window).addEventListener("load", function () {
            var $body = $("body");

            $body.removeAttr("data-preload");
            vm.setFancybox();

            if ($body.attr("data-dwaut") === "false") {
                $body.removeAttr("data-dwaut");
            }
        });
    }

    private static setAppHeader() {
        var $wrapper = $(".app-header");

        $(window).scroll(function () {
            if ($(this).scrollTop() >= 120) {
                $wrapper.attr("data-mode", "fixed");
            } else {
                $wrapper.removeAttr("data-mode");
            }
        });

        $(".search-button.open").unbind().bind("click", function () {
            if (function () { return window.matchMedia("screen and (max-width:599px)").matches; }) {
                $(".menu").attr("data-show", "false");
            }

            $(".search").attr("data-show", "true");
            $(".wrap-tap").fadeIn();

            setTimeout(function () {
                $(".search .search-input .input-box input.textbox")[0].focus();
            }, 450);
        });

        $(".search-button.close, .wrap-tap").unbind().bind("click", function () {
            $(".menu").removeAttr("data-show");
            $(".search").removeAttr("data-show");
            $(".wrap-tap").fadeOut();
        });
    }

    private static wrapMenu() {
        var delay = 0,
            $wrap = $(".wrap-tap-menu, .wrap-close");

        $(".wrap-button").unbind().bind("click", function () {
            var $menu = $(".list-items[data-wrap=\"" + $(this).attr("data-wrap") + "\"]");

            $menu.attr("data-show", "true");

            if (function () { return window.matchMedia("screen and (max-width:599px)").matches; }) {
                $(".search").removeAttr("data-show");
                $(".wrap-tap").fadeOut();
            }

            $wrap.fadeIn();
            $(".item", $menu).each(function () {
                var $item = $(this);
                $item.css({ "transition-delay": delay + "s" }).attr("data-show", "true");
                delay = delay + 0.08;
            });

            $("body").attr("data-scroll", "false");
        });

        $wrap.unbind().bind("click", function () {
            delay = 0;
            $(".list-items[data-wrap] .item").removeAttr("style").removeAttr("data-show");
            $(".list-items[data-wrap]").removeAttr("data-show");
            $("body").removeAttr("data-scroll");
            $wrap.fadeOut();
        });
    }

    private static setAnalytics() {
        $(".editor a").on("click", function () {
            GTagHelper.sendEvent("click", { page_link_url: $(this).attr("href") });
        });

        $(".ga-event[data-ga-id=\"SocialShare\"]").on("click", function () {
            GTagHelper.sendEvent("click", { social_share: $(this).attr("data-ga-label") });
        });

        $(".ga-event[data-gaevent=\"true\"]").on("click", function () {
            switch ($(this).attr("data-gacategory")) {
                case "News":
                    GTagHelper.sendEvent("click", { home_news: $(this).attr("href") });
                    break;
                case "InfoRequest":
                    if ($(this).attr("data-galabel") == "Catering list") {
                        GTagHelper.sendEvent("click", { catering_list_contact: "catering list" });
                    } else {
                        GTagHelper.sendEvent("click", { catering_casestudy_contact: $(this).attr("data-galabel") });
                    }
                    break;
            }
        });
    }

    private static setFancybox() {
        (<any>$("[data-fancybox]")).fancybox({
            fullScreen: false,
            thumbs: false,
            slideShow: false,
            iframe: {
                scrolling: "auto"
            },
            image: {
                protect: true
            }
        });
    }

    private static setCatalogueMenu() {
        var $menu = $(".app-header .menu");

        for (var i = 0; i < $(".item", $menu).length; i++) {
            var $item = $(".item", $menu)[i];

            if ($(".button", $item).text() === (<any>window).App.bag.storeCategory.replace("&amp;", "&").replace("&#xE0;", "à").replace("&#233;", "é")) {
                $($item).attr("data-selected", "true");
            }
        }
    }

    public static setCarouselProducts() {
        var btnNextArrow = '<div class="slick-arrow fastic-next" data-type="next"></div>',
            btnPrevArrow = '<div class="slick-arrow fastic-prev" data-type="prev"></div>',
            settings = {
                lazyLoad: "ondemand",
                infinite: true,
                speed: 900,
                slidesToShow: 4,
                slidesToScroll: 1,
                autoplay: true,
                autoplaySpeed: 4000,
                variableWidth: false,
                dots: false,
                nextArrow: btnNextArrow,
                prevArrow: btnPrevArrow,
                responsive: [
                    {
                        breakpoint: 1010,
                        settings: {
                            slidesToShow: 3,
                            slidesToScroll: 3
                        }
                    },
                    {
                        breakpoint: 749,
                        settings: {
                            slidesToShow: 2,
                            slidesToScroll: 2
                        }
                    },
                    {
                        breakpoint: 599,
                        settings: {
                            slidesToShow: 1,
                            slidesToScroll: 1
                        }
                    }
                ]
            };

        (<any>$(".carousel.slick-initialized")).slick("removeSlide", null, false, true);
        (<any>$(".carousel.slick-initialized")).slick("unslick");
        (<any>$(".carousel")).not(".slick-initialized").slick(settings);
    }

    private static setTooltipNewsletter() {
        var $tooltip = ".tooltip-newsletter",
            $cta = ".tooltip-newsletter .button",
            $close = ".close";

        if (!CookieHelper.getCookie("Subscribe")) {
            setTimeout(function () {
                $($tooltip).attr("data-show", "true");
            }, 15000);

            $($cta).on("click", function () {
                $($tooltip).removeAttr("data-show");
                GTagHelper.sendEvent("click", { newsletter_banner: "open" });
                CookieHelper.setCookie("Subscribe", "true", 183);
            });

            $($close).on("click", function () {
                $($tooltip).removeAttr("data-show");
                GTagHelper.sendEvent("click", { newsletter_banner: "close" });
                CookieHelper.setCookie("Subscribe", "true", 183);
            });
        }
    }
}